import 'temporal-polyfill/global';
import './css/multipass-shell.css';

import * as React from 'react';
import {createRoot} from 'react-dom/client';

import {createAppShell} from './appShell';
import {AppShellView} from './views';

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}

const bootstrap = async () => {
    const app = createAppShell();
    await app.start();

    const root = createRoot(container);
    root.render(<AppShellView app={app}/>);
};

bootstrap();
